import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getGlobalStates } from "userful-chronos-app-common-js/dist/globalstates/globalStates";
import {
    getSAMLDataFromServer,
    addSAMLDataToServer,
    updateSAMLDataToServer,
    deleteSAMLDataToServer,
} from "./msgs/samlIdentityProviderAPICallers";
import {
    AddSamlIdentityProvider,
    UpdateSamlIdentityProvider,
    DeleteSamlIdentityProvider,
    SamlIdentityProviders,
    initSamlData,
} from "userful-chronos-app-common-js/dist/models/usermgt/samlIdentityProviders";

export interface InitialStateSAML {
    samlData: SamlIdentityProviders;
    loadBool: boolean;
    saveBool: boolean;
    overlay: boolean;
}

const initialStateSAML: InitialStateSAML = {
    samlData: initSamlData(),
    loadBool: true,
    saveBool: false,
    overlay: false,
};

export const samlIdentityProviderSlice = createSlice({
    name: "samlIdentityProviderSlice",
    initialState: initialStateSAML,
    reducers: {
        getSAMLDataFromServer: (state, action: PayloadAction<{}>) => {
            getSAMLDataFromServer(getGlobalStates().keycloak.token);
        },
        setSAMLData: (state, action: PayloadAction<SamlIdentityProviders>) => {
            state.samlData = action.payload;
        },
        setLoadBool: (state, action: PayloadAction<boolean>) => {
            state.loadBool = action.payload;
        },
        addSAMLDataToServer: (state, action: PayloadAction<AddSamlIdentityProvider>) => {
            state.saveBool = true;
            addSAMLDataToServer(getGlobalStates().keycloak.token, action.payload);
        },
        updateSAMLDataToServer: (state, action: PayloadAction<UpdateSamlIdentityProvider>) => {
            state.saveBool = true;
            updateSAMLDataToServer(getGlobalStates().keycloak.token, action.payload);
        },
        deleteSAMLDataToServer: (state, action: PayloadAction<DeleteSamlIdentityProvider>) => {
            state.saveBool = true;
            deleteSAMLDataToServer(getGlobalStates().keycloak.token, action.payload);
        },
        setSaveBool: (state, action: PayloadAction<boolean>) => {
            state.saveBool = action.payload;
        },
        setOverlay: (state, action: PayloadAction<boolean>) => {
            state.overlay = action.payload;
        },
    },
});

export const samlIdentityProviderSliceActions = samlIdentityProviderSlice.actions;

export default samlIdentityProviderSlice.reducer;
